// Load analytics scripts after page renders
export const loadAnalytics = () => {
  // Only load if not already loaded
  if (window.analyticsLoaded) return;
  window.analyticsLoaded = true;

  // Stagger analytics loading to reduce main thread blocking
  setTimeout(() => loadGoogleTagManager(), 100);     // Most critical - GTM first
  setTimeout(() => loadGoogleAnalytics(), 500);      // GA after GTM is ready
  setTimeout(() => loadMoEngage(), 1000);           // MoEngage
  setTimeout(() => loadFacebookPixel(), 1500);       // FB Pixel
  setTimeout(() => loadMSClarity(), 2000);          // MS Clarity
};

const loadFacebookPixel = () => {
  // Check if already loaded
  if (window.fbq) return;
  
  (function (f, b, e, v, n, t, s) {
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    };
    if (!f._fbq) f._fbq = n; 
    n.push = n; 
    n.loaded = true; 
    n.version = '2.0';
    n.queue = []; 
    t = b.createElement(e); 
    t.async = true;
    t.src = v; 
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  
  window.fbq('init', '932544428454673');
  window.fbq('track', 'PageView');
};

const loadGoogleAnalytics = () => {
  // Check if already loaded
  if (window.gtag) return;
  
  // GA4
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-J0RPWB9L87';
  document.head.appendChild(script1);

  // Google Ads
  const script2 = document.createElement('script');
  script2.async = true;
  script2.src = 'https://www.googletagmanager.com/gtag/js?id=AW-11332974081';
  document.head.appendChild(script2);

  script1.onload = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag() { 
      window.dataLayer.push(arguments); 
    }
    gtag('js', new Date());
    gtag('config', 'G-J0RPWB9L87');
    gtag('config', 'AW-11332974081');
    window.gtag = gtag;
  };
};

const loadGoogleTagManager = () => {
  // Check if already loaded
  if (window.google_tag_manager) return;
  
  (function(w,d,s,l,i){
    w[l]=w[l]||[];
    w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
    var f=d.getElementsByTagName(s)[0];
    var j=d.createElement(s);
    var dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;
    j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
    f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-PMKNL35S');
};

const loadMoEngage = () => {
  // Check if already loaded
  if (window.Moengage) return;
  
  (function (i, s, o, g, r, a, m, n) {
    i.moengage_object = r;
    const t = {};
    const q = function (f) {
      return function () {
        (i.moengage_q = i.moengage_q || []).push({f: f, a: arguments});
      };
    };
    const f = ['track_event', 'add_user_attribute', 'add_first_name', 'add_last_name', 'add_email', 'add_mobile', 'add_user_name', 'add_gender', 'add_birthday', 'destroy_session', 'add_unique_user_id', 'moe_events', 'call_web_push', 'track', 'location_type_attribute'];
    const h = {onsite: ["getData", "registerCallback"]};
    
    for (let k in f) {
      t[f[k]] = q(f[k]);
    }
    for (let k in h) {
      for (let l in h[k]) {
        if (t[k] == null) {
          t[k] = {};
        }
        t[k][h[k][l]] = q(k + "." + h[k][l]);
      }
    }
    
    a = s.createElement(o);
    m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
    i.moe = i.moe || function () {
      n = arguments[0];
      return t;
    };
    a.onload = function () {
      if (n) {
        i[r] = window.moe(n);
      }
    };
  })(window, document, 'script', 'https://cdn.moengage.com/webpush/moe_webSdk.min.latest.js', 'Moengage');
  
  window.Moengage = window.moe({
    app_id: "OLEGV2VMFSLVRNB44ZRVYM1W",
    debug_logs: process.env.REACT_APP_MOENGAGE_DEBUG_FLAG === '1' ? 1 : 0,
    cluster: "DC_3",
    enableSPA: true,
    swPath: "/sw.js"
  });
};

const loadMSClarity = () => {
  // Check if already loaded
  if (window.clarity) return;
  
  (function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){
      (c[a].q=c[a].q||[]).push(arguments);
    };
    t=l.createElement(r);
    t.async=1;
    t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t,y);
  })(window, document, "clarity", "script", "mjzrc0q8h8");
};

